import React from 'react';
import AbstractInput from './AbstractInput';

const InputText: React.FC<{ name: string; label: string, defaultValue?: string, readOnly?: boolean, onChange?: (v: string) => void }> = ({ name, label, defaultValue, readOnly, onChange }) => (
  <AbstractInput name={name} label={label} defaultValue={defaultValue} readOnly={readOnly} onChange={onChange} type="text" />
);

export default InputText;